<template>
  <b-container fluid id="form-container" ref="formContainer">
    <b-row>
      <b-col>
        <h1>Certificate Settings</h1>
        <p>These are application settings related to certificates generated by the application.</p>
      </b-col>
    </b-row>

    <b-row>
      <b-col>
        <form-summary :validator="$v" ref="errorContainer" id="errorContainer"/>
      </b-col>
    </b-row>

    <b-row>
        <b-col>
            <BaseTextInput v-model="setting.cert_signer_name"
                            :v="$v.setting.cert_signer_name"
                            label="Name of Signer"
                            tip="This is the name that will appear as the as the signatory on certificates printed from this application."
                            slug="certSignerName"
                            setId="certSignerName"/>
        </b-col>
    </b-row>

    <b-row>
        <b-col>
            <BaseTextInput v-model="setting.cert_signer_title"
                           :v="$v.setting.cert_signer_title"
                           label="Title of Signer"
                           tip="This is the title that will appear as the as the signatory on certificates printed from this application."
                           slug="certSignerTitle"
                           setId="certSignerTitle"/>
        </b-col>
    </b-row>

    <b-row>
        <b-col>
            <BaseTextInput v-model="setting.cert_signature"
                            :v="$v.setting.cert_signature"
                            label="Image of Signature"
                            tip="URL where the image of the signatory's signature is stored in S3"
                            slug="sendLiveEmails"
                            setId="sendLiveEmails"/>
        </b-col>
    </b-row>
    
    <b-row>
      <b-col>
        <hr/>
         <b-button type="button" variant="primary" @click="saveSetting">Save</b-button>
      </b-col>
    </b-row>

  </b-container>
</template>

<script>
import axios from "axios"
import { required, url } from 'vuelidate/lib/validators'

export default {
  data: () => ({
    setting: { },
  }),
  created() {
    this.loadSetting()
    document.title = "Certificate Settings - Body Art"
  },
  validations() {
    return {
      setting: {
        cert_signer_name: {
          required
        },
        cert_signer_title: {
            required
        },
        cert_signature: {
          required,
          url
        },
      }
    }
  },
  methods: {
    loadSetting() {
      axios.post(`${process.env.VUE_APP_API_BASE_URL}/admin/settings/query`,
          ['cert_signer_name', 'cert_signer_title', 'cert_signature']
      ).then(response => { this.setting = response.data.settings })
    },
    saveSetting() {
      this.$v.$touch();
      if (this.$v.$invalid) {
          this.$nextTick(() => {
              document.getElementById('form-container').scrollIntoView()
          })
          return
      }

      axios.put(`${process.env.VUE_APP_API_BASE_URL}/admin/settings`, this.setting)
          .then(response => {
            this.$bvToast.toast('Certificate Settings Updated', {
              title: 'Status',
              toaster: 'b-toaster-top-center',
              solid: true,
              variant: 'success',
              appendToast: true,
              noAutoHide:true
            })
              this.toastFocus()
           })
    },
    toastFocus() {
        setTimeout(() => {
            let elem = document.getElementsByClassName("toast")
            elem = elem[elem.length-1]
            elem.focus()
        }, 100)
    },
  }
}
</script>

<style>

</style>
